import './style.scss';
import React from 'react';

type ListItem = {
  itemIndex: number;
  className: string;
  children: React.ReactNode;
};

export const ListItem: React.FC<ListItem> = ({ itemIndex, className, children }) => {
  return <div className={`${className} ${itemIndex % 2 ? 'listOdd' : 'listEven'}`}>{children}</div>;
};
